const KEY_SESSION_ID = 'sessionId';
const KEY_DOCUMENT_ID = 'documentId';
const KEY_DOCUMENT_VERSION = 'documentVersion';
const KEY_REDIRECT_URL = 'redirect_url';

export function getSessionId(): string {
  return sessionStorage.getItem(KEY_SESSION_ID) || '';
}

export function setSessionId(sessionId: string) {
  sessionStorage.setItem(KEY_SESSION_ID, sessionId);
}

export function setDocumentId(documentId: string) {
  sessionStorage.setItem(KEY_DOCUMENT_ID, documentId);
}

export function setDocumentVersion(documentVersion: string) {
  sessionStorage.setItem(KEY_DOCUMENT_VERSION, documentVersion);
}

export function getRedirectUrl(): string | null {
  return sessionStorage.getItem(KEY_REDIRECT_URL);
}

export function setRedirectUrl(redirect: string) {
  sessionStorage.setItem(KEY_REDIRECT_URL, redirect);
}

export function removeRedirectUrl() {
  sessionStorage.removeItem(KEY_REDIRECT_URL);
}
